import {NotiType} from '../../../graphql/generated/types';

export function getAlarmTypeFromLogName(logName: NotiType) {
  return alarmTypeLogNameMap[logName];
}

const alarmTypeLogNameMap: {[key in NotiType]: string} = {
  [NotiType.Marketing]: '기타_메시지_알림',
  [NotiType.Cash]: '캐시_알림',
  [NotiType.Ticket]: '이용권_알림',
  [NotiType.Award]: '뽑기권_알림',
  [NotiType.CashFriends]: '캐시프렌즈_알림',
  [NotiType.Update]: '업데이트_알림',
  [NotiType.Like]: '댓글_좋아요_알림',
  [NotiType.Reply]: '댓글의_댓글_알림',
  [NotiType.Event]: '이벤트_알림',
  [NotiType.Friend]: '친구_선물_알림',
  [NotiType.Gift]: '선물_알림',
  [NotiType.Notice]: '공지사항_알림',
};
